<template>
    <div>
        <div class="user-profile-container">
            <ChangeLang class="mr-3" @change="onLangChanged" />

            <span class="separator-profile">
                |
            </span>

            <img
                @click="goToUserProfilePage()"
                class="user-profile-img ml-4"
                :src="picture">

            <span
                @click="goToUserProfilePage()"
                class="user-full-name ml-4">
                {{ name }}
            </span>
        </div>
    </div>
</template>

<script>
import ChangeLang from '@/components/ChangeLang'

export default {
    name: 'UserProfile',

    components: {
        ChangeLang
    },

    computed: {
        name () {
            if (this.$store.state && this.$store.state.userName) {
                return this.$store.state.userName
            }
            return ''
        },

        picture () {
            if (this.$store.state && this.$store.state.userImage) {
                return this.$store.state.userImage
            }
            return ''
        }
    },

    methods: {

        goToUserProfilePage () {
            this.$router.push({ name: 'AccountInfo' }, () => {})
        },

        async onLangChanged (lang) {
            await this.$store.dispatch('getUserProfile', lang)
        },

        async getLangFromLocalStorage () {
            const currentLang = localStorage.getItem('lang')
            // has lang in local storage
            if (currentLang) {
                this.$vuetify.lang.current = currentLang
            }
        }
    },

    async mounted () {
        await this.getLangFromLocalStorage()
        await this.$store.dispatch('getUserProfile', this.$vuetify.lang.current)
    }
}
</script>

<style lang="scss" scoped>
.user-profile-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    object-fit: cover;
    background: #c7c7c7;
}
.user-profile-container {
    display: flex;
    justify-content: flex-end;
}
.user-full-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-family: LexendDeca;
    font-size: 18px;
    color: #131410;
    cursor: pointer;
}
.separator-profile {
    font-size: 26px;
    font-weight: 200;
    font-family: 'Roboto';
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version */
}
</style>
